import { PasseriniAPI } from '@/services/apiService';
import type { EscrituraAdicional, ListEscriturasResponse } from '../types';

export const escriturasService = {
  async list(tramiteId: string | number): Promise<ListEscriturasResponse> {
    const response = await PasseriniAPI.get(`/tramites/${tramiteId}/escrituras`);
    return response.data;
  },

  async upload(tramiteId: string | number, file: File, descripcion: string): Promise<EscrituraAdicional> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('descripcion', descripcion);

    const response = await PasseriniAPI.post(
      `/tramites/${tramiteId}/escrituras`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  async delete(escrituraId: number): Promise<void> {
    await PasseriniAPI.delete(`/escrituras-adicionales/${escrituraId}`);
  },

  async download(escritura: EscrituraAdicional): Promise<void> {
    const response = await PasseriniAPI.get(escritura.fileUrl.replace('/api', ''), {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = escritura.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
